export const BASE_URL = "https://api.gmkmc.com";
// export const BASE_URL = "http://103.118.158.156:8009";
// export const BASE_URL = "http://192.168.0.197:8009";